import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { Config } from '../../config/config';
import { useSessionService } from '../../services/session/use-session.service';

export const PrivateRoute = ({component: Component, ...rest}) => {

  const { isLoggedIn } = useSessionService();

  return <Route
    {...rest}
    render={(props) => {
      return isLoggedIn ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{pathname: Config.routePaths.main.path, state: {from: props.location}}}
        />
      );
    }
    }
  />;
};
